import { BarChartComponent } from './BarChartComponent';
import { HalfPieChartComponent } from './HalfPieChartComponent';
import { PieChartComponent } from './PieChartComponent';
import { RadarChartComponent } from './RadarChartComponent';
import { StackedBarChartComponent } from './StackedBarChartComponent';

export const Charts = {
  HalfPieChartComponent,
  PieChartComponent,
  RadarChartComponent,
  BarChartComponent,
  StackedBarChartComponent,
};
